/**
 * DemoToolbar open/closed state — persisted to localStorage so the
 * presenter's expanded state survives page refreshes during a narrated demo.
 *
 * Not persona-keyed — UI presentation state, not demo session state.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DemoToolbarState {
  open: boolean;
  setOpen: (b: boolean) => void;
  toggle: () => void;
}

export const useDemoToolbarStore = create<DemoToolbarState>()(
  persist(
    (set, get) => ({
      open: false,
      setOpen: (b) => set({ open: b }),
      toggle: () => set({ open: !get().open }),
    }),
    { name: "petci_demo_toolbar_open" },
  ),
);
